// extracted by mini-css-extract-plugin
module.exports = {"submitButton":"bO","secondary":"bP","warning":"bQ","outlined":"bR"};